const aluAdaSwitch = {

    init () {
        ///Get the current user's choice between Alu and Ada
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const currentParam = urlParams.get('a');

        ///Add the current param to all internal links

        let paramStyle = document.querySelectorAll('.paramStyle');
        let blogPage = document.getElementById('blogpage');
        let articlePage =  document.getElementById('articlepage');
        let newsPage =  document.getElementById('newspage');

        if(currentParam){
            let intlink = document.querySelectorAll('.intlink');

            for(let i=0; i < intlink.length; i++){
            
                if(intlink[i].href !== undefined){
              
                    intlink[i].href = intlink[i].href+'?a='+currentParam;
                }
            }
        }

        //Add class to change style 

        if (currentParam === "alu"){

            for(let i=0; i < paramStyle.length; i++){

                if(paramStyle[i].nodeName){

                    if(paramStyle[i].nodeName == 'A'){

                        if(blogPage || articlePage || newsPage){
                            paramStyle[i].classList.add('alu-links2')
                        } else {
                            paramStyle[i].classList.add('alu-links')
                        }

                        if(paramStyle[i].classList.contains("scrollto-button-resp")){
                            paramStyle[i].classList.add('alu-totop')
                        }
                        
                    }

                    if(paramStyle[i].nodeName == 'FORM'){
                        paramStyle[i].classList.add('alu-form')
                    }

                    if(paramStyle[i].nodeName == 'SPAN'){
                        paramStyle[i].classList.add('alu-span')
                    }


                    if(paramStyle[i].nodeName == 'DIV'){
                        paramStyle[i].classList.add('alu-div')
                    }
        
                    if(paramStyle[i].nodeName == 'NAV'){
                        paramStyle[i].classList.add('alu-menu')
                    }
        
                    if(paramStyle[i].nodeName == 'IMG'){
                        //paramStyle[i].src = 'http://aluada.local/wp-content/themes/taurine/dist/img/png/logo_alu_2022-400px.png'
                        //paramStyle[i].src = 'https://taurine-preprod.fr/alu-ada/wp-content/themes/taurine/dist/img/png/logo_alu_2022-400px.png'
                        paramStyle[i].src = 'https://alu-ada.archi/wp-content/themes/taurine/dist/img/png/logo_alu_2022-400px.png'

                    }
                }
            }

        } else if (currentParam === "ada") {

            for(let i=0; i < paramStyle.length; i++){

                if(paramStyle[i].nodeName){
                    
                    if(paramStyle[i].nodeName == 'A'){

                        if(blogPage || articlePage || newsPage){
                            paramStyle[i].classList.add('ada-links2')
                        } else {
                            paramStyle[i].classList.add('ada-links')
                        }
                    }

                    if(paramStyle[i].classList.contains("scrollto-button-resp")){
                        paramStyle[i].classList.add('ada-totop')
                    }

                    if(paramStyle[i].nodeName == 'FORM'){
                        paramStyle[i].classList.add('ada-form')
                    }

                    if(paramStyle[i].nodeName == 'SPAN'){
                        paramStyle[i].classList.add('ada-span')
                    }

                    if(paramStyle[i].nodeName == 'DIV'){
                        paramStyle[i].classList.add('ada-div')
                    }

                    if(paramStyle[i].nodeName == 'NAV'){
                        paramStyle[i].classList.add('ada-menu')
                    }

                    if(paramStyle[i].nodeName == 'IMG'){
                        //paramStyle[i].src = 'http://aluada.local/wp-content/themes/taurine/dist/img/png/logo_ada_2022-400px.png'
                        //paramStyle[i].src = 'https://taurine-preprod.fr/alu-ada/wp-content/themes/taurine/dist/img/png/logo_ada_2022-400px.png'
                        paramStyle[i].src = 'https://alu-ada.archi/wp-content/themes/taurine/dist/img/png/logo_ada_2022-400px.png'

                    }

                }
            }
        }
    }
}

export default aluAdaSwitch;